import { render, staticRenderFns } from "./SampleAdd.vue?vue&type=template&id=6a9567e9"
import script from "./SampleAdd.vue?vue&type=script&lang=js"
export * from "./SampleAdd.vue?vue&type=script&lang=js"
import style0 from "./SampleAdd.vue?vue&type=style&index=0&id=6a9567e9&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports